<template>

  <v-container class="ids-location-type-chooser">

    <v-radio-group
        v-model="locationTypeSelection"
        @change="(newVal) => { $emit('ids-location-type-change', newVal) }"
        hide-details
        class="mt-0"
      >
        <v-radio
          v-for="(ltItem) in locationTypeList" :key="ltItem.label"
          :value="ltItem.v_ortstyp"
          color="primary"
          class="ids-location-radio-item"
        >
          <template v-slot:label>
            <div class="ids-location-option-text">
              {{ltItem.v_ortstyp}} <small style="font-style: italic;">{{getSuffix(ltItem.v_ortstyp)}}</small>
            </div>
          </template>
        </v-radio>
    </v-radio-group>

  </v-container>

</template>

<script>
import Vue from 'vue';

export default {
  name: 'ids-location-type-chooser',
  props: {
    locationTypeList: { type: Array, required: true },
    locationType: { type: String, required: false, default: () => 'Aufnahmeort' }
  },
  data () {
    return {
      locationTypeSelection: this.locationType + '',
      locationTypeTexts: []
    }
  },
  created () {
    // apply values from config
    const appConfig = Vue.prototype.$appConfig;
    const idsConf = appConfig.ids;

    const configLocationTypeTexts = idsConf.locationTypeTexts;
    // apply texts (suffixes) from config to this instance
    this.locationTypeTexts =
      [ ...this.locationTypeTexts, ...configLocationTypeTexts ];
  },
  methods: {
    /**
     * Returns a location type radio label suffix
     */
    getSuffix (locType) {
      let suffix = '';
      const locTypeTxt = this.locationTypeTexts.find(ltt => {
        return ltt.locationType === locType;
      });

      if (locTypeTxt && locTypeTxt.suffix !== '') {
        suffix += ' (' + locTypeTxt.suffix + ')';
      }

      return suffix;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media only screen and (max-width: 600px) {
    .ids-location-type-chooser {
      padding: 0px 10px 10px 10px;
    }
    .ids-location-radio-item {
      margin: 1px !important
    }
    .ids-location-option-text {
      font-size: small !important;
    }
}

</style>



// WEBPACK FOOTER //
// app/ids/components/filter/IdsLocationTypeChooser.vue